import { network } from "../Screens/AdminNetwork"
let key = {};
var EnvName = 'demo';
let IPFS_IMG = "https://lazyminter.infura-ipfs.io/ipfs"
var networkVersion = ''
var BNBProvider = "";
let CAM_USD = 0.17
let Back_Url = ""
let ETH_ID = "";
let MATIC_ID = "";
let CAM_ID = "";
let decimalValues = 1000000000000000000;
let toasterOption = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}
let PayPalKey = process.env.REACT_APP_PAYPAL_KEY
if (EnvName === "demo") {
    var adminaddress = "";
    var API_URL = 'https://apistaging.lazyminter.com';
    var IMAGE_URL = 'https://apistaging.lazyminter.com/images/user';
    var PORT = 7001;
    Back_Url = 'https://apistaging.lazyminter.com';
    var Front_URL = "https://lazminter-nft-staging-adminpanel.pages.dev/";
    var defaultnet = network.ETH;
    ETH_ID = "11155111";
    MATIC_ID="80002";
    CAM_ID="501"
}
else if (EnvName === "production") {
    var adminaddress = "";
    var API_URL = 'https://api.lazyminter.com';
    var IMAGE_URL = 'https://api.lazyminter.com/images/user';
    var PORT = 2053;
    Back_Url = 'https://api.lazyminter.com'
    var Front_URL = "https://lazyminter.com/retnimyzal"
    var defaultnet = network.ETH
    ETH_ID = "1";
    MATIC_ID="137";
    CAM_ID="500"
}
else if (EnvName === "demoVib") {
    var adminaddress = "";
    var API_URL = 'http://nftdemo.bimaticz.com:8093';
    var IMAGE_URL = 'http://nftdemo.bimaticz.com:8093/images/user';
    var PORT = 8093;
    Back_Url = 'http://nftdemo.bimaticz.com:8093'
    var Front_URL = "http://nftdemo.bimaticz.com/retnimyzal"
    var defaultnet = network.ETH
    ETH_ID = "11155111";
    MATIC_ID="80002";
    CAM_ID="501"
}
else if (EnvName === "local") {
    var adminaddress = "";
    var API_URL = 'http://localhost:7001';
    var IMAGE_URL = 'http://localhost:7001/images/user';
    var PORT = 7001;
    Back_Url = 'http://localhost:7001'
    var Front_URL = "http://localhost:3001/retnimyzal"
    var defaultnet = network.MATIC
    ETH_ID = "11155111";
    MATIC_ID = "80002";
    CAM_ID = "501"
}

key = {
    secretOrKey: "",
    Recaptchakey: "",
    API: `${API_URL}/v1`,
    API_URL: API_URL,
    IMAGE_URL: IMAGE_URL,
    exchangeAddress: defaultnet.exchangeAddress,
    toasterOption: toasterOption,
    IPFS_IMG: IPFS_IMG,
    networkVersion: defaultnet.networkVersion,
    adminaddress: defaultnet.adminAddress,
    decimalValues: decimalValues,
    Back_Url: Back_Url,
    singleContract: defaultnet.singleContract,
    multipleContract: defaultnet.multipleContract,
    networkVersion: defaultnet.networkVersion,
    BNBProvider: defaultnet.BNBPROVIDER,
    TradeContract: defaultnet.TradeContract,
    Front_URL: Front_URL,
    trade: defaultnet.trade,
    ETH_ID:ETH_ID,
    MATIC_ID:MATIC_ID,
    CAM_ID:CAM_ID,
    CAM_USD:CAM_USD,
    PayPalKey: PayPalKey,
};

export default key;